import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyAccount = {
  // 获取余额明细列表
  getReceivingList(params) {
    return http.post(`${baseUrl}Company/preReceivingDetailList`, params)
  },
  // 预存流水：充值 / 扣款
  getPreReceivingFlow(params) {
    return http.post(`${baseUrl}Company/preReceivingFlow`, params)
  },
  // 获取充值明细表数据
  getRechargeList(params) {
    return http.post(`${baseUrl}Company/getRechargeList`, params)
  },
  // 修改预警金额等数据
  updateWarningAmount(params) {
    return http.post(`${baseUrl}Company/updateWarningAmount`, params)
  },
  // 余额充值
  addRecharge(params) {
    return http.post(`${baseUrl}Company/addRecharge`, params)
  },
  // 结算
  addSettlement(params) {
    return http.post(`${baseUrl}Company/addSettlement`, params)
  },
  // 查看是否支付
  isNotPay(params) {
    return http.post(`${baseUrl}Pay/isNotPay`, params)
  },
}



// WEBPACK FOOTER //
// ./src/api/companyAccount.js